import { useQueryClient } from '@tanstack/react-query';
import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useConfigContext } from '../../../contexts/ConfigProvider';
import { useMutationModalContext } from '../../../contexts/MutationModalProvider';
import useConfigActions from '../../../hooks/APIHooks/appointments/useConfigActions';
import { Config } from '../../../types/configurations';
import { fetchErrorMessage } from '../../../utils/fetchErrorMessage';
import ConfigDetailsModal from '../../CommonComps/Modals/ConfigDetailsModal';
import ConsentModal from '../../CommonComps/Modals/ConsentModal';
import CreateEditConfigModal from '../../CommonComps/Modals/CreateEditConfigModal';

const ConfigMutationModals = () => {
  // integration of react hooks here
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  // integration of context hooks here
  const {
    data,
    showUpdateModal,
    setShowUpdateModal,
    showDeleteModal,
    setShowDeleteModal,
  } = useMutationModalContext();

  const { config, showDetailsModal, setShowDetailsModal } = useConfigContext();

  console.log('CONFIG EDIT MODAL DATA: ', data);

  // integration of API hooks here
  const { deleteConfigByIdHandler } = useConfigActions('');

  // integration of tanstack query hooks here
  const queryClient = useQueryClient();

  // handler function to delete configuration declared here
  const deleteConfigHandler = async () => {
    try {
      setIsDeleting(true);

      await deleteConfigByIdHandler
        .mutateAsync({ configId: (data as Config).id })
        .then((res) => {
          if (res.status === 204) {
            toast.success('Configuration Deleted!!');

            setShowDeleteModal(false);
            queryClient.invalidateQueries({ queryKey: ['config-list'] });
          } else {
            toast.error(res.data.message || 'Configuration Deletion Failed!!');
          }
        })
        .catch((error) => toast.error(fetchErrorMessage(error)));
    } catch (error) {
      toast.error('Something Went Wrong!!');
    } finally {
      setIsDeleting(false);
    }
  };

  // rendering config mutation modals component here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showUpdateModal && (
          <CreateEditConfigModal
            title='update'
            handleModalClose={() => setShowUpdateModal(false)}
            config={data as Config}
          />
        )}
      </AnimatePresence>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showDeleteModal && (
          <ConsentModal
            titleText='Are you sure?'
            subTitle={
              <>
                Are you sure you want to delete this configuration? Once you
                delete it, you can not recover it.
              </>
            }
            isLoading={isDeleting}
            yesBtnTxt='Yes'
            yesBtnVariant='danger'
            noBtnTxt='No'
            noBtnVariant='success'
            mutationHandler={deleteConfigHandler}
            handleModalClose={() => setShowDeleteModal(false)}
          />
        )}
      </AnimatePresence>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showDetailsModal && (
          <ConfigDetailsModal
            handleModalClose={() => setShowDetailsModal(false)}
            config={config as Config}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default ConfigMutationModals;
